import styled from 'styled-components';
import { Document } from 'react-pdf';

export const DocumentStyled = styled(Document)`
    ${({ theme }) => `
        border: solid ${theme.greyF0};
        border-width: 0 1px 0 1px;
    `}
`;
